import React ,{useState , useEffect} from "react";
import {CaseListService} from "../../services/CaseService";
import MUIDataTable from "mui-datatables";
import { createTheme, ThemeProvider } from '@mui/material/styles';
// import Dropdown from 'react-bootstrap/Dropdown';
import Topbar from "../../components/common/Topbar";
import { AppBar, Toolbar, Typography } from "@mui/material";
import colorConfigs from "../../configs/colorConfigs";
import sizeConfigs from "../../configs/sizeConfigs";
import DetailTopbar from "../../components/common/DetailTopbar";
import {useParams, Link} from "react-router-dom";
import {AssignmentByCaseModel} from "../../models/Assignment";
import DatePicker from "react-datepicker";
import Loader from "../../components/common/Loader";
import {inputNumber} from "../../components/common/Helpers";
import CaseMainInfo from "../../components/common/CaseMainInfo";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';



interface URLParam {
    id : string;
}

interface IState{
    loading :boolean;
    cases_arr : [];
    assignments : AssignmentByCaseModel;
    user_arr : [];
    expect_contract_type : [];
    errorMessage : string;
}

interface IProps{}
let AssignmentEditByCase:React.FC<IProps> = () => {
    let {assignment_id} = useParams<URLParam | any>();
    let [state, setState] = useState<IState>({
        loading : false,
        cases_arr :  [],
        assignments : {
            case_id: 0,
            create_type: "",
            person_id : 0,
            proposal_price : 0,
            proposal_date : "",
            proposal_user_id : "",
            interview_date : "",
            interview_user_id : "",
            interview_time : "",
            interview_place : "",
            interview_remark : "",
            buyer_contract: "",
            seller_contract: "",
            adoption_flg: 0,
            work_start_date: ""
        },
        user_arr : [],
        expect_contract_type : [],
        errorMessage : "",
    });
    let [data , setData] = useState([]);
    const [selectedInterviewDate, setSelectedInterviewDate] = useState<Date | null>(null);
    const [selectedProposalDate, setSelectedProposalDate] = useState<Date | null>(null);

    const [selectedWorkStartDate, setSelectedWorkStartDate] = useState<Date | null>(null);
    const [person_list, setPersonList] = useState([]);
    const [person_field, setPersonFieldList] = useState([]);
    const [person_list_display, setPersonListDisplay] = useState("none");
    const [person_search_result , setSearchResult] = useState("");
    let [assign_person_id, setAssignPersonID] = useState("");
    const minDate = new Date();

    useEffect(() => {
        setState({...state, loading: true});
        if(assignment_id){
            CaseListService.editByCase(assignment_id).then((response)=>{
                setSearchResult(response.data.assignment.person_name);
                // There's other ways of formatting this return
                // console.log(response.data.assignment.interview_date.toISOString());
                setState({
                    ...state,
                    loading : false,
                    cases_arr : response.data.case,
                    user_arr : response.data.users, 
                    assignments : response.data.assignment,
                    expect_contract_type: response.data.select_options.buyer_contract
                })
                if(response.data.assignment.interview_date != ""  && response.data.assignment.interview_date != null){
                    let date = new Date(response.data.assignment.interview_date);
                    setSelectedInterviewDate(date);
                }else{
                    setSelectedInterviewDate(null);
                }
                if(response.data.assignment.proposal_date != "" && response.data.assignment.proposal_date != null){
                    let date = new Date(response.data.assignment.proposal_date);
                    setSelectedProposalDate(date);
                }else{
                    setSelectedProposalDate(null);
                }

                if(response.data.assignment.work_start_date != ""  && response.data.assignment.work_start_date != null){
                    let date = new Date(response.data.assignment.work_start_date);
                    setSelectedWorkStartDate(date);
                }else{
                    setSelectedWorkStartDate(null);
                }
               

            }).catch((error)=>{
                setState({
                    ...state,
                    loading : false,
                    errorMessage : error.message
                })
            });
        }
    }, [assignment_id]);

  let {loading, cases_arr, assignments, user_arr, expect_contract_type, errorMessage} = state;
  

  const handleDateChange = function(date:any, column_name:any){
        let selected_data:any = "";
        if(date !== null){
            selected_data = date.getFullYear() +"-"+ (date.getMonth() + 1) +"-"+ (date.getDate());
        }

        switch (column_name) {
            case "interview_date":
                setSelectedInterviewDate(date);
                setState({
                    ...state,
                    assignments : {
                        ...state.assignments,
                        interview_date : selected_data // input name 'username' set value 'event target value'
                    }
                });

                break;
                case "proposal_date":
                    setSelectedProposalDate(date);
                    setState({
                        ...state,
                        assignments : {
                            ...state.assignments,
                            proposal_date : selected_data // input name 'username' set value 'event target value'
                        }
                    });
                break;
                case "work_start_date":
                    setSelectedWorkStartDate(date);
                    setState({
                        ...state,
                        assignments : {
                            ...state.assignments,
                            work_start_date : selected_data // input name 'username' set value 'event target value'
                        }
                    });
                break;    
            default:
                break;
        }
    
    }

  

  

    let updateInput = (event:React.ChangeEvent<HTMLInputElement>):void => { // change event type declare in React
        setState({
            assignments : {
                ...state.assignments,
                [event.target.name] : event.target.value  // input name set value 'event target value'
            },
            loading : false,
            cases_arr : cases_arr,
            user_arr : user_arr,
            expect_contract_type : expect_contract_type, 
            errorMessage : "",
        });        
    };

    let update = (event : React.FormEvent<HTMLFormElement>):void => { // click event type declare in React
        event.preventDefault();
        let assignment_list = state.assignments;

        assignment_list["interview_date"] = (selectedInterviewDate != null)?selectedInterviewDate.getFullYear() +"-"+ (selectedInterviewDate.getMonth() + 1)+"-"+ selectedInterviewDate.getDate():"";
        assignment_list["proposal_date"] = (selectedProposalDate != null)?selectedProposalDate.getFullYear() +"-"+ (selectedProposalDate.getMonth() + 1)+"-"+ selectedProposalDate.getDate():"";
        assignment_list["work_start_date"] = (selectedWorkStartDate != null)?selectedWorkStartDate.getFullYear() +"-"+ (selectedWorkStartDate.getMonth() + 1)+"-"+ selectedWorkStartDate.getDate():"";

        for (let key in assignment_list) {
            if (key == "person" || key == "person_name") {
                delete assignment_list[key];
            }
        }
        setState({
            assignments : assignment_list,
            loading : false,
            cases_arr : cases_arr,
            user_arr : user_arr,
            expect_contract_type : expect_contract_type, 
            errorMessage : "",
        });
        CaseListService.assignmentUpdateByCase(state.assignments, assignment_id).then((response) => {
           window.location.href = '/cases/'+cases_arr['encode']; 
        }).catch((error) => {
            console.log(error);
            // setState({
            //     ...state,
            // })
        })
    };

    const onSelect = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        setState({
            assignments : {
                ...state.assignments,
                [e.target.name] : e.target.value  // input name 'username' set value 'event target value'
            },
            loading : false,
            cases_arr : cases_arr,
            user_arr : user_arr,
            expect_contract_type : expect_contract_type, 
            errorMessage : "",
        });
     };


     const handleAdoption = function(e:any){
        let isChecked = e.target.checked;
        let value = e.target.value;
        if(isChecked === true){
            setState({
                assignments : {
                    ...state.assignments,
                    adoption_flg: e.target.value  // input name 'username' set value 'event target value'
                },
                loading : false,
                cases_arr : cases_arr,
                user_arr : user_arr,
                expect_contract_type : expect_contract_type, 
                errorMessage : "",
            });

           
        }
    }

    const personSearch = function(){
        setAssignPersonID("");
        CaseListService.searchPerson("InitialName,full_name,kana_name,alphabet_name",state.assignments.person_id,"persons").then((response) => {
            setPersonList(response.data.data);
            setPersonFieldList(response.data.info);
            setPersonListDisplay("block");
        })
    }

    let assignPersonId = (e: React.ChangeEvent<HTMLSelectElement>): void => { // change event type declare in React
        var index = e.target.selectedIndex;
        setSearchResult(e.target[index].innerHTML);
        setState({
            assignments : {
                ...state.assignments,
                person_id : parseInt(e.target.value)  // input name set value 'event target value'
            },
            loading : false,
            cases_arr : cases_arr,
            user_arr : user_arr,
            expect_contract_type : expect_contract_type, 
            errorMessage : "",
        }); 
        setAssignPersonID(e.target.value);
        setPersonListDisplay("none");       
    };

   
    const handleKeyPress = (event:React.KeyboardEvent)  => {
        if (event.key === "Backspace") {
            setSearchResult("");
        }
      };

    return(
        <React.Fragment>
           <DetailTopbar />
        <Container>
            <div className="book-mark-container anken-detail detail">
                <Row className = "main-body">
                    <Col xxl={4} xl={4} md={4} sm={6} xs={6}>
                        <h3 className='header-left-design'>案件ID : {cases_arr['case_id']}</h3>
                    </Col>
                    <Col xxl={4} xl={4} md={4} sm={6} xs={6}>
                        <div className="text-center">
                            {( loading === true) ? <Loader /> :<> </>}
                        </div>
                    </Col>
                  
                </Row>
                <Row>
                    <Col xxl={6} xl={6} md={6} sm={6} xs={12} className="mb-3">
                        <CaseMainInfo cases_arr={cases_arr} />
                    </Col>
                    <Col xxl={6} xl={6} md={6} sm={6} xs={12}>
                        <div className="card">
                            <div className="card-body">
                                <h4>割リ当て編集</h4>
                                <form className="form assignment_add" onSubmit={update}>
                                    <input type="hidden" name="create_type" value="case_person" />
                                    <input type="hidden" name="case_id" value="{cases_arr['case_id']}" />
                                    <Row className="mt-5">
                                        <label htmlFor="person_id">技術者</label>
                                        <Col xxl={10} xl={10} md={10} sm={10} xs={8}>
                                            <input type="text"  className="form-control" onChange={updateInput}  onKeyDown={handleKeyPress} name="person_id" 
                                             value={(state.assignments.person_id != 0)?state.assignments.person_id:""}/>
                                        </Col>
                                        <Col xxl={2} xl={2} md={2} sm={2} xs={4}>
                                            <button className="btn_standard btn_search w-100" onClick={personSearch} type="button">検索</button>
                                        </Col>
                                        <span style={{fontSize:'13px'}}>{person_search_result}</span>
                                    </Row>
                                    <Row className="mt-3" style={{display: person_list_display }}>
                                        <Col xxl={12} xl={12} md={12} sm={12} xs={12}>
                                            <select name="partner_id" className="form-control"  value={assign_person_id}  onChange={assignPersonId}>
                                            <option value=""></option>
                                            {person_list.length > 0 && person_list.map((key,val) => {
                                                return(<option value={key['person_id']}>イニシャル{key["InitialName"]}、
                                               英語氏名{key["full_name"]}、 漢字氏名{key["alphabet_name"]}</option>);
                                                })
                                            }
                                            </select>
                                            {
                                              person_list.length == 0 ?
                                               <span>検索結果はありません</span>
                                               : null
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col xxl={12} xl={12} md={12} sm={12} xs={12}>
                                            <label htmlFor="proposal_price">希望単価</label>
                                            <input type="number" className="form-control" onKeyPress={inputNumber}  onChange={updateInput} name="proposal_price"  value={state.assignments.proposal_price}/>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <label htmlFor="proposal_date">提案日＆提案者</label>
                                        <Col xxl={6} xl={6} md={6} sm={6} xs={7}  className="input-box">
                                            <DatePicker 
                                                // value={(state.assignments.proposal_date != null)?state.assignments.proposal_date: ""}
                                                dateFormat="yyyy/MM/dd"
                                                locale="ja"
                                                selected={selectedProposalDate} 
                                                onChange={date =>
                                                    handleDateChange(date, "proposal_date")
                                                }
                                                autoComplete = "off"
                                                isClearable
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                onKeyDown={(e) => {
                                                    e.preventDefault();
                                                }}
                                                />
                                        </Col>
                                        <Col xxl={6} xl={6} md={6} sm={6} xs={5}  className="input-box ">
                                        <select name="proposal_user_id" id="type" onChange={onSelect} value={state.assignments.proposal_user_id} className="form-control w-100">
                                            <option value="">選択なし</option>
                                            {user_arr.map(user => {
                                                            return(<option value={user["user_id"]}> {user["name_jp"]}</option>)
                                                        })
                                                }
                                            </select>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <label htmlFor="interview_date">面談日＆面談者</label>
                                        <Col xxl={6} xl={6} md={6} sm={6} xs={7}  className="input-box ">
                                            <DatePicker 
                                                value={(state.assignments.interview_date != null)?state.assignments.interview_date: ""}
                                                dateFormat="yyyy/MM/dd"
                                                locale="ja"
                                                selected={selectedInterviewDate} 
                                                onChange={date =>
                                                    handleDateChange(date, "interview_date")
                                                }
                                                autoComplete = "off"
                                                isClearable
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                onKeyDown={(e) => {
                                                    e.preventDefault();
                                                }}
                                                />
                                        </Col>
                                        <Col xxl={6} xl={6} md={6} sm={6} xs={5}  className="input-box ">
                                        <select name="interview_user_id" id="type" onChange={onSelect} value={state.assignments.interview_user_id} className="form-control w-100">
                                            <option value="">選択なし</option>
                                            {user_arr.map(user => {
                                                            return(<option value={user["user_id"]}> {user["name_jp"]}</option>)
                                                        })
                                                }
                                            </select>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col xxl={12} xl={12} md={12} sm={12} xs={12}>
                                            <label htmlFor="interview_time">面談時刻</label>
                                            <input type="time" className="form-control" onChange={updateInput} name="interview_time"  value={state.assignments.interview_time}/>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col xxl={12} xl={12} md={12} sm={12} xs={12}>
                                            <label htmlFor="interview_place">面談場所</label>
                                            <input type="text" className="form-control" onChange={updateInput} name="interview_place"  value={state.assignments.interview_place}/>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col xxl={12} xl={12} md={12} sm={12} xs={12}>
                                            <label htmlFor="interview_remark">面談評価</label>
                                            <input type="text" className="form-control" onChange={updateInput} name="interview_remark"  value={state.assignments.interview_remark}/>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col xxl={12} xl={12} md={12} sm={12} xs={12}>
                                            <label htmlFor="buyer_contract">受注契約</label>
                                            <select name="buyer_contract" id="type" onChange={onSelect} value={state.assignments.buyer_contract} className="form-control w-100">
                                            {expect_contract_type.map(contract_type => {
                                                            return(<option value={contract_type}> {contract_type}</option>)
                                                        })
                                                }
                                            </select>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col xxl={12} xl={12} md={12} sm={12} xs={12}>
                                            <label htmlFor="seller_contract">発注契約</label>
                                            <select name="seller_contract" id="type" onChange={onSelect} value={state.assignments.seller_contract} className="form-control w-100">
                                            {expect_contract_type.map(contract_type => {
                                                            return(<option value={contract_type}> {contract_type}</option>)
                                                        })
                                                }
                                            </select>                        
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col xxl={12} xl={12} md={12} sm={12} xs={12} className="result">
                                            <label htmlFor="seller_contract">最終結果</label>
                                            <span className=""><input type="radio" className="p-2 " value="0" checked ={(state.assignments.adoption_flg == 0)? true: false} name="adoption_flg" onChange={e => handleAdoption(e)} style={{position:"relative",top:"2px"}} /> 検討中</span>
                                            <span className=""><input type="radio"  className="p-2" value="1" checked ={(state.assignments.adoption_flg == 1)? true: false} name="adoption_flg" onChange={e => handleAdoption(e)} style={{position:"relative",top:"2px"}}/> 採用</span>
                                            <span className=""><input type="radio"  className="p-2"  value="2" checked ={(state.assignments.adoption_flg == 2)? true: false} name="adoption_flg"  onChange={e => handleAdoption(e)} style={{position:"relative",top:"2px"}}/> 不採用</span>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <label htmlFor="work_start_date">稼働開始日</label>
                                        <Col xxl={12} xl={12} md={12} sm={12} xs={12}>
                                            <DatePicker 
                                                value={(state.assignments.work_start_date != null)?state.assignments.work_start_date: ""}
                                                dateFormat="yyyy/MM/dd"
                                                locale="ja"
                                                selected={selectedWorkStartDate} 
                                                onChange={date =>
                                                    handleDateChange(date, "work_start_date")
                                                }
                                                autoComplete = "off"
                                                isClearable
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                onKeyDown={(e) => {
                                                    e.preventDefault();
                                                }}
                                                />
                                            {/* <input type="text" ui-type="date" onChange={updateInput} name="work_start_date"  value={state.assignments.work_start_date} className="form-control"/> */}
                                        </Col>
                                    </Row>
                                    <Row className="mt-5  float-right">
                                        <Col xxl={6} xl={6} md={6} sm={6} xs={6}>
                                        <Link to={`/cases/${cases_arr['encode']}`} className="btn pull-right">キャンセル</Link>
                                        </Col>
                                        <Col xxl={6} xl={6} md={6} sm={6} xs={6}>
                                            <button type="submit" className="button submit-btn">更新</button>
                                        </Col>
                                    </Row>
                                </form>
                            </div>
                        </div>
                    </Col>
			    </Row>
            </div>
        </Container>
        </React.Fragment>
    );
};
export default AssignmentEditByCase;